import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  TextField,
  Breadcrumbs,
  Divider,
  Button,
} from "@mui/material";
import LK_Filter from "../images/LK_Filter";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../cssfiles/homepage.css";
import { useSelector } from "react-redux";
import { Table } from "antd";
import dayjs from "dayjs";
import Overviewbar from "./Overviewbar";
import Year from "./CommonComponents/Year";
import TicketLeftPane from "./TicketLeftPane";
import CustomDialogBox from "./CommonComponents/CustomDialogBox";
import CustomDropDown from "./CommonComponents/CustomDropDown";
import CustomTextField from "./CommonComponents/CustomTextField";
import {
  addTicketComment,
  createTicketWithAttachments,
  getTickets,
  reopenTicket,
  sendTicketRaisedEmail,
  transitionTicketStatus,
} from "../Restclient/datacollection";

const convertToIST = (epochts) => {
  const normalizedEpoch =
    typeof epochts === "number" ? epochts : Math.floor(new Date(epochts).getTime() / 1000);
  const date = new Date(normalizedEpoch * 1000);
  return date.toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour12: false,
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
};

function TicketPage() {
  const extractEmailAddresses = (input) => {
    if (Array.isArray(input)) {
      return input.flatMap((item) => extractEmailAddresses(item));
    }

    if (typeof input !== "string") {
      return [];
    }

    const matches = input.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi);

    return Array.from(new Set((matches || []).map((value) => value.trim().toLowerCase())));
  };

  const extractPrimaryEmail = (...values) => {
    for (const value of values) {
      const [firstEmail] = extractEmailAddresses(value);

      if (firstEmail) {
        return firstEmail;
      }
    }

    return "";
  };

  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates_dashboard
  );

  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate
  );
  const themechange = useSelector((state) => state.themedata.theme);
  const [value, setValue] = useState("Statistics");
  const tablist = [
    "Statistics",
    "Ticket",
    "All Tickets",
    "Open",
    "In Progress",
    "Closed",
    "Resolved",
  ];
  const statusTabs = ["Open", "In Progress", "Closed", "Resolved"];
  const [searchText, setSearchText] = useState("");
  const [timeFilter, setTimeFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([
    "Serial No",
    "Title",
    "Status",
    "Priority",
    "Created Date",
    "Assigned To",
  ]);
  const selectedProjectName = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const userid = useSelector((state) => state.logindata.username);
  const userdetails = useSelector((state) => state.logindata.userdetails);

  const [ticketData, setTicketData] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketStats, setTicketStats] = useState({
    open: 0,
    inProgress: 0,
    closed: 0,
    resolved: 0,
  });
  const totalTicketsRaised =
    ticketStats.open +
    ticketStats.inProgress +
    ticketStats.closed +
    ticketStats.resolved;
  const [requestForm, setRequestForm] = useState({
    customerEmail: "",
    requestType: "",
    complaintName: "",
    priorityCategory: "",
    subject: "",
    description: "",
    attachments: [],
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [submitMessageType, setSubmitMessageType] = useState("success");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [selectedStatusAction, setSelectedStatusAction] = useState("Resolved");
  const [customerReply, setCustomerReply] = useState("");
  const [detailActionState, setDetailActionState] = useState({
    loading: false,
    type: "success",
    message: "",
  });
  const requestTypeOptions = [
    "General Inquiry",
    "Complaint Type",
    "Bug Report",
    "Feature Request",
    "Access Request",
    "Escalation",
  ];
  const complaintNameOptions = [
    "Device/Assest Issue",
    "Data & reporting",
    "System & connectivity",
    "Billing /Payments",
    "User Accounts & Access",
    "General Equity",
  ];
  const priorityOptions = ["High", "Medium", "Low"];
  const formLabelStyle = {
    fontSize: "12px",
    fontFamily: "Roboto",
    fontWeight: 400,
    lineHeight: "16.41px",
    color: "var(--GreyVariation_2)",
  };

  const statusIdMap = {
    Open: 1,
    "In Progress": 2,
    Closed: 5,
    Resolved: 4,
  };

  const statusLabelById = {
    1: "Open",
    2: "In Progress",
    3: "In Progress",
    4: "Resolved",
    5: "Closed",
  };

  const normalizeStatusForUi = (rawStatus) => {
    const normalized = String(rawStatus || "").trim().toLowerCase();

    if (["new", "ticket created", "open"].includes(normalized)) {
      return "Open";
    }

    if (
      [
        "in progress",
        "under investigation",
        "on hold",
        "waiting for information",
        "escalated",
        "reopened",
      ].includes(normalized)
    ) {
      return "In Progress";
    }

    if (["resolved", "resolved - please verify", "resolved — please verify"].includes(normalized)) {
      return "Resolved";
    }

    if (normalized === "closed") {
      return "Closed";
    }

    return rawStatus || "Open";
  };

  const priorityIdMap = {
    High: 1,
    Medium: 2,
    Low: 3,
  };

  const priorityLabelById = {
    1: "High",
    2: "Medium",
    3: "Low",
  };

  const parseEmailSentStatus = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (["true", "1", "yes", "y", "sent", "success"].includes(normalized)) {
        return true;
      }
      if (["false", "0", "no", "n", "failed", "failure", "error"].includes(normalized)) {
        return false;
      }
    }
    return null;
  };

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const resolveRetryAfterMs = (emailNotification = {}) => {
    const retryAfterRaw =
      emailNotification?.details?.["retry-after"] ||
      emailNotification?.details?.retryAfter ||
      emailNotification?.retryAfter;

    const retryAfterSeconds = Number(retryAfterRaw);

    if (Number.isFinite(retryAfterSeconds) && retryAfterSeconds >= 0) {
      // Keep a practical floor so immediate retry bursts are avoided.
      return Math.max(retryAfterSeconds * 1000, 1000);
    }

    return 1500;
  };

  const resolveCurrentUserEmail = () => {
    const emailCandidates = [
      userdetails?.email,
      userdetails?.Email,
      userdetails?.UserEmail,
      userdetails?.Useremail,
      userdetails?.username,
      userid,
      sessionStorage.getItem("userEmail"),
      sessionStorage.getItem("email"),
      localStorage.getItem("email"),
    ];

    return extractPrimaryEmail(...emailCandidates);
  };

  const currentUserEmail = resolveCurrentUserEmail();

  const getProjectContext = () => {
    const projectList = Array.isArray(userdetails?.Projectlist)
      ? userdetails.Projectlist
      : [];

    const selectedProject = projectList.find((projectItem) => {
      const projectId = projectItem?.ProjectID || projectItem?.Projectid;
      return (
        projectId === selectedProjectName ||
        projectItem?.Projectname === selectedProjectName
      );
    });

    const resolvedProjectId =
      selectedProject?.ProjectID ||
      selectedProject?.Projectid ||
      (selectedProjectName && selectedProjectName !== "All"
        ? selectedProjectName
        : userdetails?.Projectid || "");

    const resolvedProjectName =
      selectedProject?.Projectname ||
      (selectedProjectName && selectedProjectName !== "All"
        ? selectedProjectName
        : "");

    const resolvedProjectLocation =
      selectedProject?.Projectdetails?.Location ||
      selectedProject?.ProjectLocation ||
      selectedProject?.Location ||
      "";

    return {
      projectId: resolvedProjectId,
      projectName: resolvedProjectName,
      projectLocation: resolvedProjectLocation,
      organizationId: userdetails?.Organizationid || "",
    };
  };

  const normalizeTicket = (ticket, index) => {
    const createdAtValue = ticket?.created_at || ticket?.createdAt || ticket?.createdDate;
    const createdEpoch = createdAtValue
      ? Math.floor(new Date(createdAtValue).getTime() / 1000)
      : Math.floor(Date.now() / 1000);

    const statusLabel = normalizeStatusForUi(
      ticket?.status || statusLabelById[ticket?.status_id] || "Open"
    );

    const priorityLabel =
      ticket?.priority ||
      priorityLabelById[ticket?.priority_id] ||
      "Medium";

    return {
      serialNo: index + 1,
      id: ticket?.ticket_id || ticket?.id || `TICKET-${index + 1}`,
      title: ticket?.subject || "",
      status: statusLabel,
      priority: priorityLabel,
      createdDate: createdEpoch,
      assignedTo: ticket?.customer_email || "-",
      description: ticket?.description || "",
      key: ticket?.ticket_id || ticket?.id || `${index + 1}`,
      raw: ticket,
    };
  };

  const normalizeTicketConversation = (ticket) => {
    const rawTicket = ticket?.raw || ticket || {};
    const internalComments =
      rawTicket?.internal_comments && typeof rawTicket.internal_comments === "object"
        ? rawTicket.internal_comments
        : {};

    const customerThread = Array.isArray(internalComments?.customer_thread)
      ? internalComments.customer_thread
      : [];

    if (customerThread.length > 0) {
      return customerThread
        .map((entry, index) => ({
          author: entry?.author || "Support Team",
          message: entry?.message || entry?.comment || "",
          timestamp: entry?.timestamp || entry?.createdAt || "",
          key: `customer-thread-${index}`,
        }))
        .filter((entry) => entry?.message);
    }

    const rawConversation =
      rawTicket?.conversation ||
      rawTicket?.conversations ||
      rawTicket?.comments ||
      rawTicket?.internal_comments ||
      [];

    if (Array.isArray(rawConversation)) {
      return rawConversation
        .map((entry, index) => {
          if (typeof entry === "string") {
            return {
              author: "Comment",
              message: entry,
              timestamp: "",
              key: `conversation-${index}`,
            };
          }

          const message =
            entry?.message ||
            entry?.comment ||
            entry?.text ||
            entry?.body ||
            "";

          return {
            author: entry?.author || entry?.createdBy || entry?.user || "Comment",
            message,
            timestamp: entry?.createdAt || entry?.timestamp || entry?.date || "",
            key: `conversation-${index}`,
          };
        })
        .filter((entry) => entry?.message);
    }

    if (rawConversation && typeof rawConversation === "object") {
      return Object.keys(rawConversation)
        .map((key, index) => {
          const value = rawConversation[key];
          const message = typeof value === "string" ? value : value?.message || value?.comment || "";

          return {
            author: value?.author || "Comment",
            message,
            timestamp: value?.createdAt || value?.timestamp || "",
            key: `conversation-${key}-${index}`,
          };
        })
        .filter((entry) => entry?.message);
    }

    return [];
  };

  const parseInternalComments = (value) => {
    if (!value) {
      return {};
    }

    if (typeof value === "object") {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return {};
    }
  };

  const getSelectedTicketJiraIssueKey = (ticket) => {
    const rawTicket = ticket?.raw || ticket || {};
    const internalComments = parseInternalComments(rawTicket?.internal_comments);

    return (
      rawTicket?.jira_issue_key ||
      rawTicket?.jiraIssueKey ||
      internalComments?.jira?.issue_key ||
      internalComments?.jira?.jira_issue_key ||
      null
    );
  };

  const syncSelectedTicket = (ticketId, mutateRecord) => {
    const applyMutation = (items = []) =>
      items.map((item) => {
        if (String(item?.id || item?.key) !== String(ticketId)) {
          return item;
        }

        return mutateRecord(item);
      });

    setTicketData((prev) => applyMutation(prev));
    setFilteredData((prev) => applyMutation(prev));
    setSelectedTicket((prev) => {
      if (String(prev?.id || prev?.key) !== String(ticketId)) {
        return prev;
      }

      return mutateRecord(prev);
    });
  };

  const updateDetailActionState = (message, type = "success") => {
    setDetailActionState({
      loading: false,
      type,
      message,
    });
  };

  const normalizeTicketDocuments = (ticket) => {
    const rawTicket = ticket?.raw || ticket || {};
    const rawDocuments =
      rawTicket?.attachments ||
      rawTicket?.attachment_urls ||
      rawTicket?.attachmentUrls ||
      rawTicket?.documents ||
      rawTicket?.files ||
      rawTicket?.blob_urls ||
      rawTicket?.blobUrls ||
      [];

    if (!Array.isArray(rawDocuments)) {
      return [];
    }

    return rawDocuments
      .map((documentItem, index) => {
        if (typeof documentItem === "string") {
          return {
            name: documentItem.split("/").pop() || `Document ${index + 1}`,
            url: documentItem,
          };
        }

        const url =
          documentItem?.url ||
          documentItem?.file_url ||
          documentItem?.fileUrl ||
          documentItem?.blob_url ||
          documentItem?.blobUrl ||
          documentItem?.path ||
          documentItem?.uri ||
          "";

        return {
          name:
            documentItem?.name ||
            documentItem?.file_name ||
            documentItem?.fileName ||
            documentItem?.originalname ||
            documentItem?.document_name ||
            (typeof url === "string" && url ? url.split("/").pop() : "") ||
            `Document ${index + 1}`,
          url,
        };
      })
      .filter((documentItem) => documentItem?.name);
  };

  const getDocumentAccessState = (url) => {
    if (!url) {
      return { canOpen: false, reason: "Document link not available" };
    }

    const normalizedUrl = String(url).trim();
    const isAzureBlobUrl = /blob\.core\.windows\.net/i.test(normalizedUrl);
    const hasSasToken = /[?&](sig|se|sp|sr)=/i.test(normalizedUrl);

    if (isAzureBlobUrl && !hasSasToken) {
      return {
        canOpen: false,
        reason: "Private Azure Blob URL. Backend must return a SAS URL or authenticated download endpoint.",
      };
    }

    return { canOpen: true, reason: "" };
  };

  const renderTicketDetailPanel = () => {
    if (!selectedTicket) {
      return (
        <Box
          style={{
            width: "320px",
            minWidth: "320px",
            borderLeft: "1px solid var(--HighlightedText_Stroke)",
            padding: "16px",
            backgroundColor: "var(--PrimaryBackground)",
            boxSizing: "border-box",
          }}
        >
          <Typography
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "var(--PrimaryText)",
            }}
          >
            Select a ticket to view details
          </Typography>
        </Box>
      );
    }

    const documents = normalizeTicketDocuments(selectedTicket);
    const conversations = normalizeTicketConversation(selectedTicket);
    const jiraIssueKey = getSelectedTicketJiraIssueKey(selectedTicket);
    const normalizedStatus = normalizeStatusForUi(selectedTicket?.status || "Open");
    const statusActionOptionsByStatus = {
      Open: [
        { label: "In Progress", value: "In Progress" },
        { label: "On Hold", value: "On Hold" },
        { label: "Resolved", value: "Resolved" },
      ],
      "In Progress": [
        { label: "On Hold", value: "On Hold" },
        { label: "Resolved", value: "Resolved" },
        { label: "Closed", value: "Closed" },
      ],
      Resolved: [{ label: "Closed", value: "Closed" }],
      Closed: [],
    };
    const statusActionOptions =
      statusActionOptionsByStatus[normalizedStatus] ||
      statusActionOptionsByStatus["In Progress"];
    const canReopen = ["Resolved", "Closed"].includes(normalizedStatus);
    const actionsDisabled = !jiraIssueKey || detailActionState.loading;

    return (
      <Box
        style={{
          width: "320px",
          minWidth: "320px",
          borderLeft: "1px solid var(--HighlightedText_Stroke)",
          padding: "16px",
          backgroundColor: "var(--PrimaryBackground)",
          boxSizing: "border-box",
          overflowY: "auto",
        }}
      >
        <Typography
          style={{
            fontSize: "16px",
            fontWeight: 600,
            color: "var(--PrimaryText)",
            marginBottom: "16px",
          }}
        >
          Ticket Details
        </Typography>

        <Typography style={{ ...formLabelStyle, marginBottom: "4px" }}>
          Serial No
        </Typography>
        <Typography style={{ fontSize: "13px", marginBottom: "12px", color: "var(--PrimaryText)" }}>
          {selectedTicket.serialNo || "-"}
        </Typography>

        <Typography style={{ ...formLabelStyle, marginBottom: "4px" }}>
          Subject
        </Typography>
        <Typography style={{ fontSize: "13px", marginBottom: "12px", color: "var(--PrimaryText)" }}>
          {selectedTicket.title || "-"}
        </Typography>

        <Typography style={{ ...formLabelStyle, marginBottom: "4px" }}>
          Status
        </Typography>
        <Typography style={{ fontSize: "13px", marginBottom: "12px", color: "var(--PrimaryText)" }}>
          {selectedTicket.status || "-"}
        </Typography>

        <Typography style={{ ...formLabelStyle, marginBottom: "4px" }}>
          Priority
        </Typography>
        <Typography style={{ fontSize: "13px", marginBottom: "12px", color: "var(--PrimaryText)" }}>
          {selectedTicket.priority || "-"}
        </Typography>

        <Typography style={{ ...formLabelStyle, marginBottom: "4px" }}>
          Assigned To
        </Typography>
        <Typography style={{ fontSize: "13px", marginBottom: "12px", color: "var(--PrimaryText)" }}>
          {selectedTicket.assignedTo || "-"}
        </Typography>

        <Typography style={{ ...formLabelStyle, marginBottom: "4px" }}>
          Created Date
        </Typography>
        <Typography style={{ fontSize: "13px", marginBottom: "12px", color: "var(--PrimaryText)" }}>
          {selectedTicket.createdDate ? convertToIST(selectedTicket.createdDate) : "-"}
        </Typography>

        <Typography style={{ ...formLabelStyle, marginBottom: "4px" }}>
          Jira Issue Key
        </Typography>
        <Typography style={{ fontSize: "13px", marginBottom: "12px", color: "var(--PrimaryText)" }}>
          {jiraIssueKey || "Not linked yet"}
        </Typography>

        <Typography style={{ ...formLabelStyle, marginBottom: "4px" }}>
          Description
        </Typography>
        <Box
          style={{
            marginBottom: "16px",
            padding: "12px",
            border: "1px solid var(--HighlightedText_Stroke)",
            backgroundColor: "var(--SecondaryBackground)",
            whiteSpace: "pre-wrap",
            fontSize: "13px",
            color: "var(--PrimaryText)",
          }}
        >
          {selectedTicket.description || "No description available"}
        </Box>

        <Typography style={{ ...formLabelStyle, marginBottom: "8px" }}>
          Ticket Actions
        </Typography>
        <Box
          style={{
            border: "1px solid var(--HighlightedText_Stroke)",
            backgroundColor: "var(--SecondaryBackground)",
            padding: "12px",
            marginBottom: "16px",
          }}
        >
          <TextField
            select
            SelectProps={{ native: true }}
            fullWidth
            size="small"
            value={selectedStatusAction}
            onChange={(event) => setSelectedStatusAction(event.target.value)}
            disabled={actionsDisabled || statusActionOptions.length === 0}
            style={{ marginBottom: "10px" }}
          >
            {statusActionOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
          <Button
            variant="contained"
            fullWidth
            onClick={handleStatusTransition}
            disabled={actionsDisabled || !selectedStatusAction || statusActionOptions.length === 0}
            style={{
              textTransform: "none",
              backgroundColor: "var(--LK_BrandBlue_1)",
              color: "#FFFFFF",
              marginBottom: "10px",
              borderRadius: "0px",
            }}
          >
            {detailActionState.loading ? "Updating..." : "Change Status"}
          </Button>
          <TextField
            fullWidth
            multiline
            minRows={3}
            size="small"
            value={customerReply}
            onChange={(event) => setCustomerReply(event.target.value)}
            placeholder="Add a customer-visible reply"
            disabled={actionsDisabled}
            style={{ marginBottom: "10px" }}
          />
          <Button
            variant="outlined"
            fullWidth
            onClick={handleCustomerReply}
            disabled={actionsDisabled || !customerReply.trim()}
            style={{
              textTransform: "none",
              borderColor: "var(--LK_BrandBlue_1)",
              color: "var(--LK_BrandBlue_1)",
              marginBottom: canReopen ? "10px" : "0px",
              borderRadius: "0px",
            }}
          >
            {detailActionState.loading ? "Sending..." : "Send Customer Reply"}
          </Button>
          {canReopen ? (
            <Button
              variant="outlined"
              fullWidth
              onClick={handleReopenSelectedTicket}
              disabled={actionsDisabled}
              style={{
                textTransform: "none",
                borderColor: "var(--HighlightedText_Stroke)",
                color: "var(--PrimaryText)",
                borderRadius: "0px",
              }}
            >
              {detailActionState.loading ? "Reopening..." : "Reopen Ticket"}
            </Button>
          ) : null}
          {!jiraIssueKey ? (
            <Typography style={{ fontSize: "11px", color: "var(--GreyVariation_2)", marginTop: "10px" }}>
              Jira actions become available after the backend stores the Jira issue key for this ticket.
            </Typography>
          ) : null}
          {detailActionState.message ? (
            <Typography
              style={{
                fontSize: "11px",
                color:
                  detailActionState.type === "error"
                    ? "var(--RedBaseColor)"
                    : "var(--pure-green)",
                marginTop: "10px",
              }}
            >
              {detailActionState.message}
            </Typography>
          ) : null}
        </Box>

        <Typography style={{ ...formLabelStyle, marginBottom: "8px" }}>
          Conversation
        </Typography>
        {conversations.length > 0 ? (
          <Box style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "16px" }}>
            {conversations.map((conversationItem) => (
              <Box
                key={conversationItem.key}
                style={{
                  border: "1px solid var(--HighlightedText_Stroke)",
                  padding: "10px 12px",
                  backgroundColor: "var(--SecondaryBackground)",
                }}
              >
                <Typography style={{ fontSize: "12px", fontWeight: 600, color: "var(--PrimaryText)" }}>
                  {conversationItem.author}
                </Typography>
                <Typography
                  style={{
                    fontSize: "12px",
                    color: "var(--PrimaryText)",
                    whiteSpace: "pre-wrap",
                    marginTop: "4px",
                  }}
                >
                  {conversationItem.message}
                </Typography>
                {conversationItem.timestamp ? (
                  <Typography
                    style={{ fontSize: "11px", color: "var(--GreyVariation_2)", marginTop: "6px" }}
                  >
                    {conversationItem.timestamp}
                  </Typography>
                ) : null}
              </Box>
            ))}
          </Box>
        ) : (
          <Typography style={{ fontSize: "12px", color: "var(--GreyVariation_2)", marginBottom: "16px" }}>
            No conversation available
          </Typography>
        )}

        <Typography style={{ ...formLabelStyle, marginBottom: "8px" }}>
          Documents
        </Typography>
        {documents.length > 0 ? (
          <Box style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {documents.map((documentItem, index) => {
              const accessState = getDocumentAccessState(documentItem.url);

              return (
                <Box
                  key={`${documentItem.name}-${index}`}
                  style={{
                    border: "1px solid var(--HighlightedText_Stroke)",
                    padding: "10px 12px",
                    backgroundColor: "var(--SecondaryBackground)",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "12px",
                      color: "var(--PrimaryText)",
                      marginBottom: "6px",
                      wordBreak: "break-word",
                    }}
                  >
                    {documentItem.name}
                  </Typography>
                  {accessState.canOpen ? (
                    <a
                      href={documentItem.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "12px",
                        color: "var(--LK_BrandBlue_1)",
                        textDecoration: "none",
                      }}
                    >
                      Open document
                    </a>
                  ) : (
                    <Typography style={{ fontSize: "12px", color: "var(--GreyVariation_2)" }}>
                      {accessState.reason}
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        ) : (
          <Typography style={{ fontSize: "12px", color: "var(--GreyVariation_2)" }}>
            No documents attached
          </Typography>
        )}
      </Box>
    );
  };

  const loadTickets = async () => {
    try {
      const { projectId, organizationId } = getProjectContext();
      const response = await getTickets({
        project_id: projectId,
        organization_id: organizationId,
      });

      const ticketsArray =
        response?.data?.data?.tickets ||
        response?.data?.tickets ||
        response?.data?.data ||
        [];

      if (Array.isArray(ticketsArray) && ticketsArray.length > 0) {
        const normalizedTickets = ticketsArray.map(normalizeTicket);
        setTicketData(normalizedTickets);
        setFilteredData(normalizedTickets);
        setSelectedTicket((prev) =>
          normalizedTickets.find((ticket) => ticket.key === prev?.key) || normalizedTickets[0] || null
        );
        calculateStats(normalizedTickets);
        return;
      }

      setTicketData([]);
      setFilteredData([]);
      setSelectedTicket(null);
      calculateStats([]);
    } catch (error) {
      setTicketData([]);
      setFilteredData([]);
      setSelectedTicket(null);
      calculateStats([]);
    }
  };

  const handletabchange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSearch = (e) => {
    const text = e.target.value.toLowerCase();
    setSearchText(text);
    applyFilters(text, timeFilter);
  };

  const handleTimeFilterChange = (event) => {
    const filter = event.target.value;
    setTimeFilter(filter);
    applyFilters(searchText, filter);
  };

  const handleRequestFormChange = (field, fieldValue) => {
    setRequestForm((prev) => ({
      ...prev,
      [field]: fieldValue,
    }));
  };

  useEffect(() => {
    if (currentUserEmail && !requestForm.customerEmail) {
      setRequestForm((prev) => ({
        ...prev,
        customerEmail: currentUserEmail,
      }));
    }
  }, [currentUserEmail, requestForm.customerEmail]);

  const handleRequestTypeChange = (selectedType) => {
    setRequestForm((prev) => ({
      ...prev,
      requestType: selectedType,
      complaintName: selectedType === "Complaint Type" ? prev.complaintName : "",
    }));
  };

  const handleAttachmentChange = (event) => {
    const files = Array.from(event.target.files || []);
    setRequestForm((prev) => ({
      ...prev,
      attachments: files,
    }));
  };

  const handleCloseSuccessDialog = () => {
    setOpenSuccessDialog(false);
    setSubmitMessage("");
  };

  const handleStatusTransition = async () => {
    if (!selectedTicket) {
      return;
    }

    const jiraIssueKey = getSelectedTicketJiraIssueKey(selectedTicket);
    if (!jiraIssueKey) {
      updateDetailActionState(
        "This ticket is not linked to a Jira issue yet, so status sync is unavailable.",
        "error"
      );
      return;
    }

    try {
      setDetailActionState({ loading: true, type: "success", message: "" });

      await transitionTicketStatus({
        jira_issue_key: jiraIssueKey,
        target_status: selectedStatusAction,
        ticket_id: selectedTicket.id,
        operate_ticket_id: selectedTicket.id,
      });

      syncSelectedTicket(selectedTicket.id, (record) => ({
        ...record,
        status: normalizeStatusForUi(selectedStatusAction),
        raw: {
          ...(record?.raw || {}),
          status: selectedStatusAction,
          status_id: statusIdMap[normalizeStatusForUi(selectedStatusAction)] || record?.raw?.status_id,
        },
      }));

      setValue("All Tickets");
      updateDetailActionState(`Ticket moved to ${selectedStatusAction}.`);
      await loadTickets();
    } catch (error) {
      updateDetailActionState(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to update the ticket status.",
        "error"
      );
    }
  };

  const handleCustomerReply = async () => {
    if (!selectedTicket) {
      return;
    }

    const cleanReply = customerReply.trim();
    if (!cleanReply) {
      updateDetailActionState("Reply message is required.", "error");
      return;
    }

    const jiraIssueKey = getSelectedTicketJiraIssueKey(selectedTicket);
    if (!jiraIssueKey) {
      updateDetailActionState(
        "This ticket is not linked to a Jira issue yet, so reply sync is unavailable.",
        "error"
      );
      return;
    }

    try {
      setDetailActionState({ loading: true, type: "success", message: "" });

      await addTicketComment({
        jira_issue_key: jiraIssueKey,
        comment: cleanReply,
        customer_visible: true,
        ticket_id: selectedTicket.id,
        operate_ticket_id: selectedTicket.id,
      });

      syncSelectedTicket(selectedTicket.id, (record) => {
        const rawTicket = record?.raw || {};
        const internalComments = parseInternalComments(rawTicket?.internal_comments);
        const customerThread = Array.isArray(internalComments?.customer_thread)
          ? internalComments.customer_thread
          : [];

        return {
          ...record,
          raw: {
            ...rawTicket,
            internal_comments: {
              ...internalComments,
              customer_thread: [
                ...customerThread,
                {
                  author: "Support Team",
                  message: cleanReply,
                  type: "NEW_REPLY",
                  timestamp: new Date().toISOString(),
                  visible_to_customer: true,
                },
              ],
            },
          },
        };
      });

      setCustomerReply("");
      updateDetailActionState("Customer-visible reply sent to Jira and synced.");
      await loadTickets();
    } catch (error) {
      updateDetailActionState(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to add the customer-visible reply.",
        "error"
      );
    }
  };

  const handleReopenSelectedTicket = async () => {
    if (!selectedTicket) {
      return;
    }

    const jiraIssueKey = getSelectedTicketJiraIssueKey(selectedTicket);
    if (!jiraIssueKey) {
      updateDetailActionState(
        "This ticket is not linked to a Jira issue yet, so reopen sync is unavailable.",
        "error"
      );
      return;
    }

    try {
      setDetailActionState({ loading: true, type: "success", message: "" });

      await reopenTicket({
        jira_issue_key: jiraIssueKey,
        ticket_id: selectedTicket.id,
        operate_ticket_id: selectedTicket.id,
      });

      syncSelectedTicket(selectedTicket.id, (record) => ({
        ...record,
        status: "In Progress",
        raw: {
          ...(record?.raw || {}),
          status: "Reopened",
          status_id: statusIdMap["In Progress"],
        },
      }));

      setValue("All Tickets");
      updateDetailActionState("Ticket reopened and synced with Jira.");
      await loadTickets();
    } catch (error) {
      updateDetailActionState(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to reopen the ticket.",
        "error"
      );
    }
  };

  useEffect(() => {
    const normalizedStatus = normalizeStatusForUi(selectedTicket?.status || "Open");

    setCustomerReply("");
    setDetailActionState({
      loading: false,
      type: "success",
      message: "",
    });

    if (["Open", "In Progress"].includes(normalizedStatus)) {
      setSelectedStatusAction("Resolved");
      return;
    }

    if (normalizedStatus === "Resolved") {
      setSelectedStatusAction("Closed");
      return;
    }

    setSelectedStatusAction("In Progress");
  }, [selectedTicket]);

  const handleRequestSubmit = async () => {
    setSubmitMessage("");
    setSubmitMessageType("success");
    setOpenSuccessDialog(false);

    if (!requestForm.subject || !requestForm.description) {
      setSubmitMessageType("error");
      setSubmitMessage("Subject and description are required.");
      return;
    }

    if (!requestForm.requestType) {
      setSubmitMessageType("error");
      setSubmitMessage("Request type is required.");
      return;
    }

    const { projectId, projectName, projectLocation, organizationId } =
      getProjectContext();

    if (!projectId || !organizationId) {
      setSubmitMessageType("error");
      setSubmitMessage("Project and organization are required to create a ticket.");
      return;
    }

    const sanitizedCustomerEmail = extractPrimaryEmail(
      requestForm.customerEmail,
      currentUserEmail,
    );

    const payload = {
      subject: requestForm.subject,
      description: requestForm.description,
      customer_email: sanitizedCustomerEmail,
      priority_id: priorityIdMap[requestForm.priorityCategory] || 2,
      status_id: statusIdMap.Open,
      request_type: requestForm.requestType,
      complaint_type:
        requestForm.requestType === "Complaint Type"
          ? requestForm.complaintName
          : null,
      project_id: projectId,
      project_name: projectName || null,
      organization_id: organizationId,
      project_location: projectLocation || null,
      internal_comments: {},
    };

    try {
      setIsSubmitting(true);

      if (!payload.customer_email) {
        setSubmitMessageType("error");
        setSubmitMessage("Unable to resolve a valid customer email. Please enter a valid email address.");
        return;
      }

      const createResponse = await createTicketWithAttachments(
        payload,
        requestForm.attachments,
      );

      const createdTicket =
        createResponse?.data?.data?.ticket ||
        createResponse?.data?.ticket ||
        createResponse?.data?.data ||
        {};

      const createdTicketId =
        createdTicket?.ticket_id ||
        createdTicket?.id ||
        createdTicket?.TicketID ||
        createdTicket?.ticketId ||
        null;

      const emailSent =
        parseEmailSentStatus(createResponse?.data?.emailNotification?.sent) ??
        parseEmailSentStatus(createResponse?.data?.emailNotification?.isSent) ??
        parseEmailSentStatus(createResponse?.data?.emailSent) ??
        parseEmailSentStatus(createResponse?.data?.data?.emailNotification?.sent) ??
        parseEmailSentStatus(createResponse?.data?.data?.emailNotification?.isSent);

      const backendEmailStatusCode =
        Number(createResponse?.data?.emailNotification?.statusCode) ||
        Number(createResponse?.data?.data?.emailNotification?.statusCode) ||
        null;

      const backendEmailErrorCode =
        createResponse?.data?.emailNotification?.errorCode ||
        createResponse?.data?.data?.emailNotification?.errorCode ||
        "";

      let finalEmailError =
        createResponse?.data?.emailNotification?.error ||
        createResponse?.data?.data?.emailNotification?.error ||
        "";

      let finalEmailSent = emailSent;

      const initialEmailNotification =
        createResponse?.data?.emailNotification ||
        createResponse?.data?.data?.emailNotification ||
        {};

      const shouldRetryOnThrottle =
        finalEmailSent === false &&
        (backendEmailStatusCode === 429 ||
          String(backendEmailErrorCode).toLowerCase() === "toomanyrequests");

      const shouldRetryUnknownStatus = finalEmailSent === null;

      const shouldRetryEmail =
        (shouldRetryOnThrottle || shouldRetryUnknownStatus) &&
        createdTicketId &&
        payload.customer_email;

      // Retry only for transient/unknown cases. This avoids immediate hard-failure loops.
      if (shouldRetryEmail) {
        try {
          const fallbackEmailPayload = {
            ticketId: createdTicketId,
            ticket_id: createdTicketId,
            customerEmail: payload.customer_email,
            customer_email: payload.customer_email,
            subject: payload.subject,
            description: payload.description,
            project_id: payload.project_id,
            organization_id: payload.organization_id,
          };

          let retryDelayMs = resolveRetryAfterMs(initialEmailNotification);

          for (let attempt = 0; attempt < 2 && finalEmailSent !== true; attempt += 1) {
            await wait(retryDelayMs);

            const fallbackEmailResponse = await sendTicketRaisedEmail(
              fallbackEmailPayload,
            );

            finalEmailSent =
              parseEmailSentStatus(fallbackEmailResponse?.data?.sent) ??
              parseEmailSentStatus(fallbackEmailResponse?.data?.isSent) ??
              parseEmailSentStatus(fallbackEmailResponse?.data?.emailSent) ??
              parseEmailSentStatus(
                fallbackEmailResponse?.data?.emailNotification?.sent,
              ) ??
              finalEmailSent;

            finalEmailError =
              fallbackEmailResponse?.data?.emailNotification?.error ||
              fallbackEmailResponse?.data?.message ||
              finalEmailError;

            retryDelayMs = resolveRetryAfterMs(
              fallbackEmailResponse?.data?.emailNotification,
            );
          }
        } catch {
          // Keep original backend email status if fallback call fails.
        }
      }

      setRequestForm({
        customerEmail: currentUserEmail || "",
        requestType: "",
        complaintName: "",
        priorityCategory: "",
        subject: "",
        description: "",
        attachments: [],
      });
      setSubmitMessageType("success");
      setSubmitMessage(
        finalEmailSent === true
          ? "Ticket submitted successfully and email notification was sent."
          : finalEmailSent === false
            ? `Ticket submitted successfully, but email notification could not be sent.${finalEmailError ? ` Reason: ${finalEmailError}` : ""}`
            : "Ticket submitted successfully. Email notification status is unavailable."
      );
      setOpenSuccessDialog(true);
      await loadTickets();
    } catch (error) {
      setSubmitMessageType("error");
      setSubmitMessage(
        error?.response?.data?.message ||
          "Ticket submission failed. Please verify backend ticket endpoints."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const applyFilters = (searchText, timeFilter) => {
    let filtered = ticketData;

    // Filter by status tabs only
    if (statusTabs.includes(value)) {
      filtered = filtered.filter((item) => item.status === value);
    }

    // Apply search filter
    if (searchText) {
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchText)
        )
      );
    }

    // Apply timestamp filter
    if (timeFilter) {
      const now = dayjs();
      filtered = filtered.filter((item) => {
        const recordDate = dayjs(item.createdDate * 1000);
        if (timeFilter === "24h")
          return recordDate.isAfter(now.subtract(1, "day"));
        if (timeFilter === "7d")
          return recordDate.isAfter(now.subtract(7, "day"));
        if (timeFilter === "30d")
          return recordDate.isAfter(now.subtract(30, "day"));
        return true;
      });
    }

    setFilteredData(filtered);
  };

  const calculateStats = (data) => {
    const stats = {
      open: data.filter((t) => t.status === "Open").length,
      inProgress: data.filter((t) => t.status === "In Progress").length,
      closed: data.filter((t) => t.status === "Closed").length,
      resolved: data.filter((t) => t.status === "Resolved").length,
    };
    setTicketStats(stats);
  };

  const ticketColumns = [
    {
      title: "Serial No",
      dataIndex: "serialNo",
      sorter: (a, b) => (a.serialNo || 0) - (b.serialNo || 0),
    },
    {
      title: "Title",
      dataIndex: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      sorter: (a, b) => a.priority.localeCompare(b.priority),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      render: (createdDate) => convertToIST(createdDate),
      sorter: (a, b) => a.createdDate - b.createdDate,
    },
    {
      title: "Assigned To",
      dataIndex: "assignedTo",
      sorter: (a, b) => a.assignedTo.localeCompare(b.assignedTo),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (description) => description || "-",
    },
  ];

  const [pagesize, setPagesize] = useState(353);

  // Filter columns dynamically based on selectedColumns
  const filteredTicketColumns = ticketColumns.filter((col) =>
    selectedColumns.includes(col.title)
  );

  const [pathselected, setPathselected] = useState([
    <Typography
      key="Plant"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Plant
    </Typography>,
    <Typography
      key="Dashboard"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Dashboard
    </Typography>,
    <Typography
      key="Tickets"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Tickets
    </Typography>,
  ]);

  // Sample data for demonstration
  const mockTicketData = [
    {
      id: 1,
      serialNo: 1,
      title: "Fix login page bug",
      status: "Open",
      priority: "High",
      createdDate: Math.floor(Date.now() / 1000),
      assignedTo: "John Doe",
      description: "Login page showing error on mobile devices",
      key: 1,
    },
    {
      id: 2,
      serialNo: 2,
      title: "Update dashboard layout",
      status: "In Progress",
      priority: "Medium",
      createdDate: Math.floor(Date.now() / 1000) - 86400,
      assignedTo: "Jane Smith",
      description: "Redesign dashboard for better UX",
      key: 2,
    },
    {
      id: 3,
      serialNo: 3,
      title: "API optimization",
      status: "Closed",
      priority: "Low",
      createdDate: Math.floor(Date.now() / 1000) - 172800,
      assignedTo: "Mike Johnson",
      description: "Optimize API response time",
      key: 3,
    },
    {
      id: 4,
      serialNo: 4,
      title: "Database migration",
      status: "Resolved",
      priority: "High",
      createdDate: Math.floor(Date.now() / 1000) - 259200,
      assignedTo: "Sarah Lee",
      description: "Migrate to new database system",
      key: 4,
    },
    {
      id: 5,
      serialNo: 5,
      title: "Security audit",
      status: "In Progress",
      priority: "High",
      createdDate: Math.floor(Date.now() / 1000) - 345600,
      assignedTo: "Alex Chen",
      description: "Perform security audit on backend",
      key: 5,
    },
    {
      id: 6,
      serialNo: 6,
      title: "UI consistency",
      status: "Open",
      priority: "Medium",
      createdDate: Math.floor(Date.now() / 1000) - 432000,
      assignedTo: "Emma Wilson",
      description: "Ensure UI consistency across pages",
      key: 6,
    },
  ];

  useEffect(() => {
    loadTickets();
  }, [selectedProjectName, userdetails?.Organizationid, userdetails?.Projectid]);

  useEffect(() => {
    applyFilters(searchText, timeFilter);
  }, [value]);

  useEffect(() => {
    if (overviewstate) {
      setPagesize(293);
    } else {
      setPagesize(258);
    }
  }, [overviewstate]);

  return (
    <Box className="Ticket-Module" sx={{}}>
      <Overviewbar />
      <div
        style={{ display: "flex", flexDirection: "row", marginRight: "18px" }}
      >
        <div
          className="breadcrumb-reporting"
          style={{ flexGrow: 1, marginRight: "4px", marginLeft: "16px" }}
        >
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={{ color: "var(--GreyVariation_2)" }}
              />
            }
            style={{ padding: "10px 12px 10px 12px", textAlign: "center" }}
          >
            {pathselected}
          </Breadcrumbs>
        </div>
        <TextField
          required
          className="textfield"
          placeholder="Search..."
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            marginRight: "4px",
            backgroundColor: "var(--SecondaryBackground)",
            justifyContent: "center",
            paddingLeft: "4px",
            "& .MuiInputBase-input:focus": {
              color: "#008CD7",
            },
            "& .MuiInputBase-root": {
              fontFamily: "Roboto",
              fontSize: "12px",
              fontWeight: "400",
              color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
            },
            "& .MuiInput-root .MuiInputBase-input": {},
            "& .MuiInputBase-root::before": {
              borderBottom: `0px solid ${
                themechange === "light" ? "#3C3C3C" : "#FFFFFF"
              }`,
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
              borderBottom: "0px solid #008CD7",
            },
            "& .MuiInputBase-root::after": {
              borderBottom: "0px solid #008CD7",
            },
          }}
          label=""
          value={searchText}
          onChange={handleSearch}
          variant="standard"
        />
        <Year />
      </div>

      {/* Tickets List Section */}
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          padding: "0px 16px",
          boxSizing: "border-box",
          marginTop: "16px",
        }}
      >
        <TicketLeftPane
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
          selectedTab={value}
        />
        <Box
          style={{
            width: "100%",
            boxSizing: "border-box",
            height: "auto",
            backgroundColor: "var(--PrimaryBackground)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <Tabs
              value={value}
              onChange={handletabchange}
              TabIndicatorProps={{ hidden: true }}
              sx={{
                "& .MuiTabs-indicator": {
                  display: "none",
                  height: "0px",
                  borderRadius: "0px",
                  backgroundColor: "var(--action-button-light)",
                  borderBottom: "1px solid var(--SecondaryBackground)",
                },
                "& .Mui-selected": {
                  color: "var(--LK_BrandBlue_1) !important",
                  fontWeight: "700 !important",
                  backgroundColor: "var(--PrimaryBackground)",
                  borderTop: "1px solid var(--HighlightedText_Stroke)",
                  borderLeft: "1px solid var(--HighlightedText_Stroke)",
                  borderRight: "1px solid var(--HighlightedText_Stroke)",
                  borderBottom: "1px solid var(--SecondaryBackground)",
                },
                "& .MuiTab-root": {
                  padding: "8px 8px 6px 8px !important",
                  margin: "0px !important",
                  minWidth: "63px",
                },
                minHeight: "30px",
                marginBottom: "-1px",
              }}
            >
              {tablist.map((tab) => {
                return (
                  <Tab
                    sx={{
                      minHeight: "30px",
                      height: "30px",
                    }}
                    style={{
                      color: "var(--GreyVariation_2)",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "16.75px",
                      textTransform: "capitalize",
                    }}
                    value={tab}
                    label={tab}
                  >
                    {tab}
                  </Tab>
                );
              })}
            </Tabs>
          </div>

          {/* Statistics Tab Content */}
          {value === "Statistics" && (
            <Box
              style={{
                padding: "16px",
                backgroundColor: "var(--SecondaryBackground)",
                borderRadius: "0px",
                border: "1px solid var(--HighlightedText_Stroke)",
                height: `calc(100vh - ${pagesize}px)`,
                boxSizing: "border-box",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box style={{ display: "flex", flexDirection: "row", marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
                  }}
                >
                  Ticket Statistics
                </Typography>
                <div style={{ flexGrow: 1 }}></div>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "var(--GreyVariation_2)",
                  }}
                >
                  Total: {totalTicketsRaised}
                </Typography>
              </Box>
              <Divider style={{ marginBottom: "16px", backgroundColor: "var(--HighlightedText_Stroke)" }} />
              <Box
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                  flexWrap: "nowrap",
                  overflowX: "auto",
                }}
              >
                <Box
                  style={{
                    textAlign: "left",
                    padding: "14px 16px",
                    backgroundColor: "var(--PrimaryBackground)",
                    borderRadius: "0px",
                    border: "1px solid rgba(0, 140, 215, 0.22)",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
                    minWidth: "170px",
                    flex: 1,
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "26px",
                      fontWeight: 700,
                      color: "var(--LK_BrandBlue_1)",
                      lineHeight: "30px",
                    }}
                  >
                    {ticketStats.open}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "6px",
                      color: "var(--GreyVariation_2)",
                      letterSpacing: "0.3px",
                    }}
                  >
                    Open
                  </Typography>
                </Box>
                <Box
                  style={{
                    textAlign: "left",
                    padding: "14px 16px",
                    backgroundColor: "var(--PrimaryBackground)",
                    borderRadius: "0px",
                    border: "1px solid rgba(0, 92, 142, 0.22)",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
                    minWidth: "170px",
                    flex: 1,
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "26px",
                      fontWeight: 700,
                      color: "var(--LK_BrandBlue)",
                      lineHeight: "30px",
                    }}
                  >
                    {ticketStats.inProgress}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "6px",
                      color: "var(--GreyVariation_2)",
                      letterSpacing: "0.3px",
                    }}
                  >
                    In Progress
                  </Typography>
                </Box>
                <Box
                  style={{
                    textAlign: "left",
                    padding: "14px 16px",
                    backgroundColor: "var(--PrimaryBackground)",
                    borderRadius: "0px",
                    border: "1px solid rgba(0, 66, 101, 0.22)",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
                    minWidth: "170px",
                    flex: 1,
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "26px",
                      fontWeight: 700,
                      color: "var(--LK_BrandBlue_2)",
                      lineHeight: "30px",
                    }}
                  >
                    {ticketStats.closed}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "6px",
                      color: "var(--GreyVariation_2)",
                      letterSpacing: "0.3px",
                    }}
                  >
                    Closed
                  </Typography>
                </Box>
                <Box
                  style={{
                    textAlign: "left",
                    padding: "14px 16px",
                    backgroundColor: "var(--PrimaryBackground)",
                    borderRadius: "0px",
                    border: "1px solid rgba(0, 140, 215, 0.22)",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
                    minWidth: "170px",
                    flex: 1,
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "26px",
                      fontWeight: 700,
                      color: "var(--LK_BrandBlue_1)",
                      lineHeight: "30px",
                    }}
                  >
                    {ticketStats.resolved}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "6px",
                      color: "var(--GreyVariation_2)",
                      letterSpacing: "0.3px",
                    }}
                  >
                    Resolved
                  </Typography>
                </Box>
                <Box
                  style={{
                    textAlign: "left",
                    padding: "14px 16px",
                    backgroundColor: "var(--PrimaryBackground)",
                    borderRadius: "0px",
                    border: "1px solid rgba(0, 92, 142, 0.26)",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
                    minWidth: "170px",
                    flex: 1,
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "26px",
                      fontWeight: 700,
                      color: "var(--LK_BrandBlue)",
                      lineHeight: "30px",
                    }}
                  >
                    {totalTicketsRaised}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "6px",
                      color: "var(--GreyVariation_2)",
                      letterSpacing: "0.3px",
                    }}
                  >
                    Total Tickets Raised
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  marginTop: "6px",
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  flex: 1,
                }}
              >
                <Divider
                  style={{
                    marginBottom: "12px",
                    backgroundColor: "var(--HighlightedText_Stroke)",
                  }}
                />
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "var(--PrimaryText)",
                    marginBottom: "8px",
                  }}
                >
                  All Tickets
                </Typography>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "var(--PrimaryBackground)",
                    padding: "8px",
                    width: "100%",
                    boxSizing: "border-box",
                    minHeight: 0,
                    flex: 1,
                    overflow: "auto",
                  }}
                >
                  <Table
                    columns={filteredTicketColumns}
                    dataSource={ticketData}
                    pagination={{ pageSize: 10 }}
                    className="anttable"
                    locale={{
                      emptyText: (
                        <span style={{ color: "var(--GreyBaseColor)" }}>
                          No tickets found
                        </span>
                      ),
                    }}
                    style={{
                      width: "100%",
                      colorBgContainer: "var(--primary-backgroundLK)",
                    }}
                    showSorterTooltip={false}
                  />
                </Box>
              </Box>
            </Box>
          )}

          {value === "Ticket" && (
            <Box
              style={{
                padding: "16px",
                backgroundColor: "var(--SecondaryBackground)",
                borderRadius: "0px",
                border: "1px solid var(--HighlightedText_Stroke)",
              }}
            >
              <Typography
                style={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "var(--PrimaryText)",
                  marginBottom: "16px",
                }}
              >
                New Request
              </Typography>
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  columnGap: "32px",
                  rowGap: "12px",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    justifyContent: "flex-start",
                  }}
                >
                  <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Typography style={{ ...formLabelStyle, width: "100px" }}>
                      Request Type
                    </Typography>
                    <CustomDropDown
                      options={requestTypeOptions}
                      onChange={(selectedValue) =>
                        handleRequestTypeChange(selectedValue)
                      }
                      defaultValue={requestForm.requestType}
                      width={"150px"}
                    />
                  </Box>
                  {requestForm.requestType === "Complaint Type" && (
                    <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <Typography style={{ ...formLabelStyle, width: "110px" }}>
                        Complaint Name
                      </Typography>
                      <CustomDropDown
                        options={complaintNameOptions}
                        onChange={(selectedValue) =>
                          handleRequestFormChange("complaintName", selectedValue)
                        }
                        defaultValue={requestForm.complaintName}
                        width={"150px"}
                      />
                    </Box>
                  )}
                </Box>
                <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <Typography style={{ ...formLabelStyle, width: "120px" }}>
                    Customer Email
                  </Typography>
                  <CustomTextField
                    defaultValue={requestForm.customerEmail || currentUserEmail}
                    onChange={(value) =>
                      handleRequestFormChange("customerEmail", value)
                    }
                    width={250}
                    maxLength={120}
                  />
                </Box>
              </Box>
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  columnGap: "32px",
                  rowGap: "12px",
                  marginTop: "12px",
                }}
              >
                <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <Typography style={{ ...formLabelStyle, width: "120px" }}>
                    Priority Category
                  </Typography>
                  <CustomDropDown
                    options={priorityOptions}
                    onChange={(selectedValue) =>
                      handleRequestFormChange("priorityCategory", selectedValue)
                    }
                    defaultValue={requestForm.priorityCategory}
                    width={"250px"}
                  />
                </Box>
                <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <Typography style={{ ...formLabelStyle, width: "120px" }}>
                    Subject
                  </Typography>
                  <CustomTextField
                    defaultValue={requestForm.subject}
                    onChange={(value) => handleRequestFormChange("subject", value)}
                    width={250}
                    maxLength={120}
                  />
                </Box>
              </Box>
              <Box style={{ marginTop: "12px", display: "flex", alignItems: "flex-start", gap: "12px" }}>
                <Typography style={{ ...formLabelStyle, width: "120px", marginTop: "4px" }}>
                  Description
                </Typography>
                <CustomTextField
                  defaultValue={requestForm.description}
                  onChange={(value) => handleRequestFormChange("description", value)}
                  width={560}
                  multiline={true}
                  minRows={3}
                  maxRows={5}
                  maxLength={500}
                />
              </Box>
              <Box style={{ marginTop: "16px" }}>
                <Button
                  variant="outlined"
                  component="label"
                  style={{
                    textTransform: "none",
                    borderColor: "var(--HighlightedText_Stroke)",
                    color: "var(--PrimaryText)",
                  }}
                >
                  Add Attachments
                  <input
                    type="file"
                    hidden
                    multiple
                    onChange={handleAttachmentChange}
                  />
                </Button>
                <Typography
                  style={{
                    marginTop: "8px",
                    fontSize: "12px",
                    color: "var(--GreyVariation_2)",
                  }}
                >
                  {requestForm.attachments.length > 0
                    ? `Selected: ${requestForm.attachments
                        .map((file) => file.name)
                        .join(", ")}`
                    : "No attachments selected"}
                </Typography>
              </Box>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "16px",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleRequestSubmit}
                  disabled={
                    isSubmitting ||
                    !(requestForm.customerEmail || currentUserEmail) ||
                    !requestForm.requestType ||
                    (requestForm.requestType === "Complaint Type" &&
                      !requestForm.complaintName) ||
                    !requestForm.priorityCategory ||
                    !requestForm.subject ||
                    !requestForm.description
                  }
                  style={{
                    textTransform: "none",
                    backgroundColor: "var(--LK_BrandBlue_1)",
                    color: "#FFFFFF",
                    borderRadius: "0px",
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Submit Request"}
                </Button>
              </Box>
              {submitMessage && submitMessageType === "error" && (
                <Typography
                  style={{
                    marginTop: "10px",
                    fontSize: "12px",
                    color:
                      submitMessageType === "error"
                        ? "var(--RedBaseColor)"
                        : "var(--pure-green)",
                  }}
                >
                  {submitMessage}
                </Typography>
              )}
            </Box>
          )}

          {/* Status-wise table tabs */}
          {statusTabs.includes(value) && (
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                backgroundColor: "var(--SecondaryBackground))",
                padding: "8px",
                width: "100%",
                height: `calc(100vh - ${pagesize}px)`,
                overflow: "auto",
                boxSizing: "border-box",
                border: "1px solid var(--HighlightedText_Stroke)",
                overflow: "auto",
              }}
            >
              <Table
                columns={filteredTicketColumns}
                dataSource={filteredData}
                pagination={false}
                className="anttable"
                locale={{
                  emptyText: (
                    <span style={{ color: "var(--GreyBaseColor)" }}>
                      {" "}
                      No match found
                    </span>
                  ),
                }}
                style={{
                  width: "100%",
                  colorBgContainer: "var(--primary-backgroundLK)",
                }}
                showSorterTooltip={false}
              />
            </Box>
          )}

          {/* All Tickets dedicated left-list and right-details view */}
          {value === "All Tickets" && (
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                backgroundColor: "var(--SecondaryBackground))",
                padding: "8px",
                width: "100%",
                height: `calc(100vh - ${pagesize}px)`,
                boxSizing: "border-box",
                border: "1px solid var(--HighlightedText_Stroke)",
                overflow: "auto",
              }}
            >
              <Table
                columns={filteredTicketColumns}
                dataSource={filteredData}
                pagination={false}
                onRow={(record) => ({
                  onClick: () => setSelectedTicket(record),
                  style: {
                    cursor: "pointer",
                    backgroundColor:
                      selectedTicket?.key === record.key
                        ? "rgba(0, 140, 215, 0.08)"
                        : "transparent",
                  },
                })}
                className="anttable"
                locale={{
                  emptyText: (
                    <span style={{ color: "var(--GreyBaseColor)" }}>
                      No match found
                    </span>
                  ),
                }}
                style={{
                  width: "100%",
                  colorBgContainer: "var(--primary-backgroundLK)",
                }}
                showSorterTooltip={false}
              />
              {renderTicketDetailPanel()}
            </Box>
          )}
        </Box>
      </Box>
      <CustomDialogBox
        dialogTitle={"Ticket Submitted"}
        dialogText={submitMessage}
        openDialog={openSuccessDialog}
        handleCloseDialog={handleCloseSuccessDialog}
        handleConfirmDialog={handleCloseSuccessDialog}
        confirmText={"OK"}
        type={"Success"}
      />
    </Box>
  );
}

export default TicketPage;
